// import {testURL} from '../url/index'
import request from '@/util/request'

export function getWebsites (param) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/getWebsiteList?type=' + param,
    method: 'get'
  })
}
export function getWebsiteListByTitle (param) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/getWebsiteListByTitle?title=' + param,
    method: 'get'
  })
}

export function getWebsiteTypeList () {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/getWebsiteTypeList',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/website.js